import { render, staticRenderFns } from "./ProvisionamentoOnus.vue?vue&type=template&id=36290e94&"
import script from "./ProvisionamentoOnus.vue?vue&type=script&lang=js&"
export * from "./ProvisionamentoOnus.vue?vue&type=script&lang=js&"
import style0 from "./ProvisionamentoOnus.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports